import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import API from "../Service/Baseservice";
import UploadIcon from "../../Assets/img/upload.png";
import CharIcon from "../../Assets/img/word.png";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import OurServicesPreview from "./OurServicesPreview";

const ServicesEdit = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const lang = queryParams.get("lang");
    const languageId = lang ? Number(lang) : 1;


    const serviceData = location.state?.service;
    const ourserviceId = location.state?.ourservice_id;


    useEffect(() => {
        if (!serviceData) {
            navigate(`/ourservices/${id}?lang=${formData.language_id}`);
        }


    }, [serviceData]);


    const [loading, setLoading] = useState(false);
    const [imageFile, setImageFile] = useState(null);
    const [imagePreview, setImagePreview] = useState(serviceData?.image || null);
    const [uploadedUrl, setUploadedUrl] = useState(null);
    const [isUpdating, setIsUpdating] = useState(false);
    const [showPreviewOurService, setShowPreviewOurService] = useState(false);
    const [previewData, setPreviewData] = useState(null);

    const [formData, setFormData] = useState({
        listofservice_id: serviceData?.listofservice_id || id,
        ourservice_id: serviceData?.ourservice_id,
        language_id: serviceData?.language_id,
        heading: serviceData?.heading || "",
        image: serviceData?.image || "",
        description: serviceData?.description || "",
        requirements: serviceData?.requirements || "",
        status: serviceData?.status || "active",
        active: serviceData?.active || 1,
        orderby:serviceData?.order_by
    });


    const [popup, setPopup] = useState({
        show: false,
        title: "",
        message: "",
        type: "",
    });

    const getPlainTextLength = (html) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        return (div.textContent || "").length;
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImageFile(file);
            setImagePreview(URL.createObjectURL(file));
        }
    };

    const handleUpdate = () => {
        if (!formData.heading || !formData.description || !formData.requirements) {
            setPopup({
                show: true,
                title: "Warning",
                message: "Please fill all required fields",
                type: "info",
            });
            return;
        }
        setIsUpdating(true);
    };


    useEffect(() => {
        if (isUpdating) {
            if (imageFile) {
                const reader = new FileReader();
                reader.onloadend = () => {
                    const base64Image = reader.result;

                    const body = {
                        name: imageFile.name,
                        image: [
                            {
                                name: imageFile.name,
                                type: imageFile.type,
                                size: `${imageFile.size} bytes`,
                                base64: base64Image,
                            },
                        ],
                    };

                    setLoading(true);
                    API.post("imageUpload/add", body)
                        .then((res) => setUploadedUrl(res.data?.url))
                        .catch(() => {
                            setPopup({
                                show: true,
                                title: "Error",
                                message: "Image upload failed",
                                type: "failed",
                            });
                            setIsUpdating(false);
                        });
                };
                reader.readAsDataURL(imageFile);
            } else {
                setUploadedUrl(formData.image);
            }
        }
    }, [isUpdating]);

    // Update service
    useEffect(() => {
        if (uploadedUrl && isUpdating) {
            const payload = {
                ...formData,
                language_id: formData.language_id,
                image: uploadedUrl,
                order_by:formData.orderby
            };


            API.post("listofservice_edit/update", payload)
                .then(() => {
                    setPopup({
                        show: true,
                        title: "Success",
                        message: "Service updated successfully!",
                        type: "success",
                    });

                    setTimeout(() => {
                        navigate(`/ourservices/${formData.ourservice_id}?lang=${formData.language_id}`);
                    }, 2000);

                })
                .catch(() => {
                    setPopup({
                        show: true,
                        title: "Error",
                        message: "Failed to update service",
                        type: "failed",
                    });
                })
                .finally(() => {
                    setLoading(false);
                    setIsUpdating(false);
                });
        }
    }, [uploadedUrl]);

    const handlePreview = () => {
        if (!formData.heading || !formData.description || !formData.requirements) {
            setPopup({
                show: true,
                title: "Warning",
                message: "Please fill all required fields to preview",
                type: "info",
            });
            return;
        }

        setPreviewData({
            ...formData,
            listofservice_id: "preview",
            image: imagePreview,
        });
        setShowPreviewOurService(true);
    };
    const MAX_DESC = 4000;
    const MAX_REQ = 1000;

    const [lastValidEditorData, setLastValidEditorData] = useState({
        description: "",
        requirements: "",
    });
    const handleLimitedEditor = (html, field, editor, max) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        const text = div.textContent || "";

        if (text.length <= max) {
            // save last valid
            setLastValidEditorData(prev => ({
                ...prev,
                [field]: html,
            }));

            setFormData(prev => ({
                ...prev,
                [field]: html,
            }));
        } else {
            // restore last valid → blocks typing, allows backspace
            editor.setData(lastValidEditorData[field] || "");
        }
    };

    return (
        <div className="newss-containeradd">
            <div className="service-header-bar">
                <h2>Edit Services</h2>
                <div className="button-group">
                    <button onClick={handlePreview} className="saves-btn">
                        Preview
                    </button>
                    <button className="saves-btn" onClick={handleUpdate}>
                        {loading ? "Update" : "Update"}
                    </button>
                    <button
                        onClick={() => navigate(`/ourservices/${formData.ourservice_id}?lang=${formData.language_id}`)}
                        className="cancel-btn "
                    >
                        Back
                    </button>
                </div>
            </div>

            <div className="service-container">

                {/* LEFT */}
                <div className="left-form">
                    <div className="form-group">
                        <label className="news-description-label">
                            <span className="label-text">Heading <span className="required">*</span></span>
                            <div className="char-wrapper">
                                <img src={CharIcon} />
                                <span className="char-count">
                                    {getPlainTextLength(formData.heading)}/50
                                </span>
                            </div>
                        </label>

                        <input
                            type="text"
                            name="heading"
                            value={formData.heading}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="upload-section">
                        <label>Upload Image <span className="required">*</span></label>
                        <div className="service-upload-box">
                            {imagePreview ? (
                                <img src={imagePreview} className="preview-img" alt="Preview" />
                            ) : (
                                <>
                                    <img src={UploadIcon} className="upload-icon" />
                                    <p>Click to upload</p>
                                </>
                            )}
                            <input type="file" accept="image/*" onChange={handleImageUpload} />
                        </div>
                    </div>
                </div>

                {/* RIGHT */}
                <div className="serviceadd-right-section">

                    {/* DESCRIPTION */}
                    <div className="news-form-group ouradd-editor-small">
                        <label className="news-description-label">
                            <span>Description <span className="required">*</span></span>
                            <div className="char-wrapper">
                                <img src={CharIcon} />
                                <span className="char-count">
                                    {getPlainTextLength(formData.description)}/4000
                                </span>
                            </div>
                        </label>

                        <CKEditor
                            editor={ClassicEditor}
                            data={formData.description}
                            onReady={(editor) =>
                                setLastValidEditorData(prev => ({
                                    ...prev,
                                    description: editor.getData(),
                                }))
                            }
                            onChange={(e, editor) =>
                                handleLimitedEditor(
                                    editor.getData(),
                                    "description",
                                    editor,
                                    MAX_DESC
                                )
                            }
                            config={{
                                toolbar: [
                                    "undo", "redo", "|",
                                    "heading", "|",
                                    "bold", "italic", "underline", "|",
                                    "bulletedList", "numberedList",
                                ],
                            }}
                        />

                    </div>

                    {/* REQUIREMENTS */}
                    <div className="news-form-group ouradd-editor-small">
                        <label className="news-description-label">
                            <span>Requirements <span className="required">*</span></span>
                            <div className="char-wrapper">
                                <img src={CharIcon} />
                                <span className="char-count">
                                    {getPlainTextLength(formData.requirements)}/1000
                                </span>
                            </div>
                        </label>

                        <CKEditor
                            editor={ClassicEditor}
                            data={formData.requirements}
                            onReady={(editor) =>
                                setLastValidEditorData(prev => ({
                                    ...prev,
                                    requirements: editor.getData(),
                                }))
                            }
                            onChange={(e, editor) =>
                                handleLimitedEditor(
                                    editor.getData(),
                                    "requirements",
                                    editor,
                                    MAX_REQ
                                )
                            }
                            config={{
                                toolbar: [
                                    "undo", "redo", "|",
                                    "heading", "|",
                                    "bold", "italic", "underline", "|",
                                    "bulletedList", "numberedList",
                                ],
                            }}
                        />

                    </div>
                </div>
            </div>

            {popup.show && (
                <div className="popup-overlay">
                    <div className={`popup-box popup-${popup.type}`}>
                        <h3>{popup.title}</h3>
                        <p>{popup.message}</p>
                        <button
                            className="btn ok-btn"
                            onClick={() => setPopup({ ...popup, show: false })}
                        >
                            OK
                        </button>
                    </div>
                </div>
            )}
            {showPreviewOurService && (
                <OurServicesPreview
                    previewService={previewData}
                    setShowPreviewOurService={setShowPreviewOurService}
                />
            )}
        </div>
    );
};

export default ServicesEdit;
